import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { HomeInstagramComponent } from './home-instagram/home-instagram.component';



@NgModule({
  declarations: [
    HomeInstagramComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
  ]
})
export class InstagramModule{ }